module.exports = __webpack_public_path__ + "img/bigLogoBelgravia.a05c3642.png";